export default __webpack_public_path__ + "static/favicon-1f472061a178ef953c19d828b0bb4ec5.png";